import { createCustomElement } from "../model.js";
import { registerComponent } from "../model/registration.js";
import { devWarning } from "../attributes/errors.js";
if (!window.WebComponents) {
  window.WebComponents = {};
}
const registerWebComponent = ({ name, element }) => {
  devWarning(
    `registerWebComponent() is deprecated. Use Model.registerComponent("${name}", element, { eager: false }) instead.`
  );
  if (window.customElements.get(name)) {
    return;
  }
  const hasElement = document.getElementsByTagName(name).length > 0;
  if (!hasElement) {
    return;
  }
  window.WebComponents[name] = element;
  window.customElements.define(name, element);
};
function webComponent(config) {
  return () => {
    devWarning(
      `Register.webComponent() is deprecated. Use Model.registerComponent() instead.`
    );
    const normalizedConfig = {
      ...config,
      attributes: config.attributes ? Array.isArray(config.attributes) ? config.attributes : [config.attributes] : void 0
    };
    const element = createCustomElement(normalizedConfig);
    try {
      registerComponent(config.tagName, element, { eager: false });
    } catch {
      registerWebComponent({ name: config.tagName, element });
      return;
    }
    window.WebComponents[config.tagName] = element;
  };
}
export {
  registerWebComponent,
  webComponent
};
//# sourceMappingURL=register.js.map
